import { usePermission } from '@backstage/plugin-permission-react';
import {
  techdocsFeedbackReadPermission,
  techdocsFeedbackUpdatePermission,
} from '@internal/plugin-techdocs-feedback-common';

export const useTechDocsFeedbackReadAccess = () => {
  const { allowed, loading, error } = usePermission({
    permission: techdocsFeedbackReadPermission,
  });
  return { canRead: !loading && !error && allowed, loading, error };
};

export const useTechDocsFeedbackUpdateAccess = () => {
  const { allowed, loading, error } = usePermission({
    permission: techdocsFeedbackUpdatePermission,
  });
  return { canUpdate: !loading && !error && allowed };
};
